import { gql } from '@apollo/client';

import { SUB_MGMT_SUBSCRIPTION_FIELDS } from './fragments';

/**
 * Queries minimum required data to render lazy-load dashboard.
 *
 * We also get cart UUIDs just for a count of overall active carts to determine
 * whether or not to use pre-credit total.
 */
export const GET_SUBSCRIPTION_UUIDS_V2 = gql`
  query getSubscriptionUUIDsV2 {
    dashboardSubscriptionsV2 {
      uuid
      startWeek
      endWeek
      status
      displayName
      carts {
        uuid
      }
      status
    }
  }
`;

export const GET_SUBSCRIPTION_BY_ID_V2 = gql`
  query getSubscriptionV2ByUuid($uuid: UUID!) {
    subscriptionV2(uuid: $uuid) {
      ...subMgmtFields
    }
  }
  ${SUB_MGMT_SUBSCRIPTION_FIELDS}
`;
